import React, { PureComponent } from "react";
import KBELogo from "../img/kbe-Logo-66454.png";
import { Link } from "react-router-dom";
import queryString from "query-string";
import AppConfig from "../../../config/appconfig.json";

class VerifyAccount extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHashValid: false,
      isLoading: false,
      isError: false,
      errorMsg: ""
    };
  }

  componentDidMount() {
    this.setState({ isError: false, isLoading: true });
    const values = queryString.parse(this.props.location.search);
    if (values.hash) {
      const hash = values.hash;
      let isActivateAccountFailed = false;
      const request = {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      };
      fetch(
        `${AppConfig.BACK_END_URL}/APIClient/ActivateAccount?hash=` + hash,
        request
      )
        .then(response => {
          if (response.ok === false) {
            isActivateAccountFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isActivateAccountFailed) {
            const respObj = JSON.parse(json);
            this.setState({
              isError: true,
              errorMsg: respObj.Message,
              isLoading: false
            });
          } else {
            this.setState({ isHashValid: true, isLoading: false });
          }
        })
        .catch(() => {
          this.setState({
            isError: true,
            errorMsg:
              "Something went wrong when resetting your password. Please try again.",
            isLoading: false
          });
        });
    } else {
      this.setState({
        isLoading: false,
        isError: true,
        errorMsg: "Error! Page not found."
      });
    }
  }

  render() {
    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={KBELogo} alt="logo" />
              {this.state.isLoading ? (
                <p style={{ minWidth: 450 }}>Loading ...</p>
              ) : (
                <div>
                  {this.state.isError ? <p>{this.state.errorMsg}</p> : <div />}
                </div>
              )}
            </div>
            {this.state.isHashValid ? (
              <div>
                <p>Your account has been activated successfully.</p>
              </div>
            ) : (
              <div />
            )}
            <div className="account__have-account">
              <p>
                Already have an account? <Link to="/">Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VerifyAccount;



// WEBPACK FOOTER //
// ./src/pages/account/register/VerifyAccount.js